const EXTERNAL_ID_RE = /^[A-Za-z0-9_-]{6,128}$/;

const clean = (value) => String(value || "").trim();

/** Normalize legacy/new event fields to external families.firebase_family_id. */
export function normalizeEventFamilyId(data = {}) {
  // Native notification producers historically used `familyId` for the
  // PostgreSQL family UUID while also sending the canonical external id in
  // `familyFirebaseId`. Prefer the explicit external contract when present;
  // otherwise keep accepting the legacy aliases for backward compatibility.
  const explicitExternalCandidates = [
    data.familyFirebaseId,
    data.data?.familyFirebaseId,
    data.raw?.familyFirebaseId,
  ].map(clean).filter(Boolean);

  const legacyCandidates = [
    data.familyId,
    data.family_id,
    data.data?.familyId,
    data.data?.family_id,
    data.raw?.familyId,
    data.raw?.family_id,
  ].map(clean).filter(Boolean);

  const candidates = explicitExternalCandidates.length
    ? explicitExternalCandidates
    : legacyCandidates;
  if (!candidates.length) return null;
  const unique = [...new Set(candidates)];
  // families.firebase_family_id is generated as String(Date.now()) for new
  // families, so an all-numeric value is a valid canonical external id.
  if (unique.length !== 1 || !EXTERNAL_ID_RE.test(unique[0])) return null;
  return unique[0];
}

export function withFamilyAliases(data = {}, familyId) {
  const normalized = clean(familyId);
  if (!EXTERNAL_ID_RE.test(normalized)) return { ...data };
  return { ...data, familyId: normalized, familyFirebaseId: normalized };
}
